const SET_LOADING_PESQUISA_PROCESSOS_UNIFICADA = 'SET_LOADING_PESQUISA_PROCESSOS_UNIFICADA';
const SET_RESULTADO_PESQUISA_PROCESSOS_UNIFICADA = 'SET_RESULTADO_PESQUISA_PROCESSOS_UNIFICADA';
const SET_ERRO_PESQUISA_PROCESSOS_UNIFICADA = 'SET_ERRO_PESQUISA_PROCESSOS_UNIFICADA';

function buildInitialStates() {
  return {
    loading: false,
    // null = nenhuma pesquisa feita ainda; array (mesmo vazio) = pesquisa já retornou.
    resultado: null,
    erro: null,
  };
}

function changeLoadingHandler(states, actions) {
  return { ...states, loading: actions.loading };
}

function changeResultadoHandler(states, actions) {
  return { ...states, resultado: actions.resultado };
}

function changeErroHandler(states, actions) {
  return { ...states, erro: actions.erro };
}

export const setLoadingAction = loading => ({
  type: SET_LOADING_PESQUISA_PROCESSOS_UNIFICADA,
  loading,
});

export const setResultadoAction = resultado => ({
  type: SET_RESULTADO_PESQUISA_PROCESSOS_UNIFICADA,
  resultado,
});

export const setErroAction = erro => ({
  type: SET_ERRO_PESQUISA_PROCESSOS_UNIFICADA,
  erro,
});

export default (states = buildInitialStates(), actions) => {
  switch (actions.type) {
    case SET_LOADING_PESQUISA_PROCESSOS_UNIFICADA:
      return changeLoadingHandler(states, actions);
    case SET_RESULTADO_PESQUISA_PROCESSOS_UNIFICADA:
      return changeResultadoHandler(states, actions);
    case SET_ERRO_PESQUISA_PROCESSOS_UNIFICADA:
      return changeErroHandler(states, actions);
    default:
      return states;
  }
};
